import { AfterViewInit, Component, ViewChild, OnInit } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ComponentFactoryResolver, Injector, OnDestroy, SimpleChange, ViewContainerRef } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { BehaviorSubject, of, toArray } from 'rxjs';
import { merge, Observable, of as observableOf, pipe } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { FormControl } from '@angular/forms';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatSelectChange } from '@angular/material/select';

import { ExhibitorService, Exhibitor, ExhibitorTable } from '../services/exhibitor.service';

import { PhutureIavatarComponent } from '../@components/phuture-iavatar/phuture-iavatar.component';

import { environment } from '../../environments/environment';

import { Logger } from '@core';

import { AuthQuery } from '@app/auth/auth.query';

import { JournalService, MailService, Mail } from '@core';

import {
  bewegungsdatenColumnHeaders,
  bewegungsdatenColumnKeys,
  flattenBewegungsdaten,
} from '../shared/bewegungsdaten-export';

export interface EmpFilter {
  name: string;
  options: string[];
  defaultValue: string;
}

export interface filterOption {
  name: string;
  value: string;
  isdefault: boolean;
}

@Component({
  selector: 'app-exhibitors-view',
  templateUrl: './exhibitor-view.component.html',
  styleUrls: ['./exhibitor-view.component.scss'],
})
export class ExhibitorsViewComponent implements OnInit, AfterViewInit {
  // content values
  _txt_subline = environment.txt_Subline;
  _txt_event_domain = environment.txt_Event_Domain;

  // output row selection
  @Output() exhibitorSelected = new EventEmitter<Exhibitor>();

  //
  //

  displayedColumns: string[] = [
    't_exhibitorid',

    'info2', // status

    'profile_image',

    'organisation',
    'name',
    'vorname',
    'funktion',
    'adresse',
    'plz',
    'stadt',
    'telefon',
    'fax',
    'email',
    'web',

    //'beschreibung2',
    //'info3',

    //'country',

    // - french-rendez-vous: 'decharge_resp_civile',
    // - french-rendez-vous: 'estimate',

    /*

    'storno_accepted',
    'dsgvo_accepted',
    'agb_accepted',
    */

    'chkcity1',
    'chkcity2',

    // logistics columns injected dynamically in ngOnInit when show_logistics_columns = true

    'special_wishes',

    'actions',
  ];

  private readonly logisticsColumns = [
    'garage_day1',
    'garage_day2',
    'lunch_day1',
    'lunch_day2',
    'attendance_event',
    'hotel_stay_night',
    'transfer_arrival',
    'transfer_return',
    'data1',       // transfer_from
    'flight_booked',
    'data2',       // transfer_type
  ];

  readonly bewegungsdatenColumns = bewegungsdatenColumnKeys('exhibitor');
  readonly bewegungsdatenHeaders = bewegungsdatenColumnHeaders('exhibitor');

  // environment
  imageStorage = environment.eplusSystem + '/_fileDB/images/exhibitor/';

  _eventYear = environment.event_year;
  _veranstalter = environment.veranstalter;
  _hotel_info = environment.hotel_info;
  _event_space = environment.event_space;
  _event_date = environment.event_date;
  _book_night = environment.book_night;
  _cancel_date = environment.cancel_date;
  // ---

  exhibitorTable: ExhibitorTable;

  totalItems: number;
  exhibitors$: Observable<Exhibitor[]>;

  dataSource = new MatTableDataSource<Exhibitor>();

  isLoading = true;

  searchTerm$ = new BehaviorSubject<string>('');

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  pageSizes = [5, 10, 20, 50, 100, 200, 500, this.dataSource.data.length];
  initPageSize = 100;

  searchValue: string;
  //searchKeywordFilter = new FormControl();

  countries: string[] = [
    'All',
    'Austria',
    'Bosnia-Herzegovina',
    'Bulgaria',
    'Croatia',
    'Czech Republic',
    'France',
    'Germany',
    'Hungary',
    'Kosovo',
    'Macedonia',
    'Montenegro',
    'Poland',
    'Romania',
    'Serbia',
    'Slovakia',
    'Slovenia',
    'Switzerland',
  ];

  stati: string[] = ['All', 'Register New', 'Approved', 'First-Start Done', 'Last Year'];
  days: string[] = ['All', 'Day 1 - ' + environment.day_1, 'Day 2 - ' + environment.day_2];
  empFilters: EmpFilter[] = [];
  defaultValue = 'All';
  filterDictionary = new Map<string, string>();
  //dataSourceFilters = new MatTableDataSource();
  filters$ = new BehaviorSubject<string>('');

  // dilaog und sidenav
  openSidebar = false;
  @ViewChild('sidenav') sidenav;
  selectedExhibitor: Exhibitor;
  @ViewChild('ExhibitorContainer', { read: ViewContainerRef }) quizContainer: ViewContainerRef;

  constructor(
    private exhibitorService: ExhibitorService,
    private cfr: ComponentFactoryResolver,
    private injector: Injector,
    private router: Router,
    private route: ActivatedRoute,
    private authQuery: AuthQuery,
    private http: HttpClient
  ) {}

  ngOnInit() {
    //this.empFilters.push({ name: 'Country', options: this.countries, defaultValue: this.defaultValue });
    this.empFilters.push({ name: 'Status', options: this.stati, defaultValue: this.defaultValue });
    this.empFilters.push({ name: 'Days', options: this.days, defaultValue: this.defaultValue });

    const insertAt = this.displayedColumns.indexOf('special_wishes');
    this.displayedColumns.splice(insertAt, 0, ...this.bewegungsdatenColumns);

    if (environment.show_logistics_columns) {
      const logisticsAt = this.displayedColumns.indexOf('special_wishes');
      this.displayedColumns.splice(logisticsAt, 0, ...this.logisticsColumns);
    }
  }

  maxall: number = 20;
  /*
  getPageSizeOptions(): number[] {
    if (this.dataSource.paginator.length>this.maxall)
      return [5, 10, 20,  this.dataSource.paginator.length];
    else
      return [5, 10, 20, this.maxall];
    }
  }
  */

  ngAfterViewInit() {
    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

    this.dataSource.paginator = this.paginator;
    //this.dataSource.sort = this.sort;

    merge(this.filters$, this.searchTerm$.pipe(debounceTime(400), distinctUntilChanged()), this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap((term) => {
          this.isLoading = true;
          //var sTerm = term && typeof term == 'string' ? term.toString() : '';
          return this.getTableData$(
            this.paginator.pageIndex + 1,
            this.paginator.pageSize,
            this.sort.active,
            this.sort.direction,
            //sTerm.trim(),
            this.searchTerm$.getValue(),
            this.filters$.getValue()
          ).pipe(catchError(() => observableOf(null)));
        }),
        map((exTable) => {
          if (exTable == null) return [];
          this.totalItems = exTable.total;
          this.isLoading = false;

          return exTable.data.map((data) => {
            return <Exhibitor>{
              ...data,
              ...flattenBewegungsdaten(data.json, 'exhibitor'),
              decharge_resp_civile: data.decharge_resp_civile == -1 ? 1 : 0,
              estimate: data.estimate == '-1' ? '1' : 0,
              garage_day1: data.garage_day1 == -1 ? 1 : 0,
              garage_day2: data.garage_day2 == -1 ? 1 : 0,
              lunch_day1: data.lunch_day1 == -1 ? 1 : 0,
              lunch_day2: data.lunch_day2 == -1 ? 1 : 0,
              attendance_event: data.attendance_event == -1 ? 1 : 0,
              hotel_stay_night: data.hotel_stay_night == -1 ? 1 : 0,
              transfer_arrival: data.transfer_arrival == -1 ? 1 : 0,
              transfer_return: data.transfer_return == -1 ? 1 : 0,
              flight_booked: data.flight_booked == -1 ? 1 : 0,
            };
          });
          //return visTable.data;
        })
      )
      .subscribe((exhibitors: Exhibitor[]) => {
        this.exhibitors$ = of(exhibitors);
        this.dataSource = new MatTableDataSource(exhibitors);

        //reset paginator
        //this.paginator.pageIndex = 1;
      });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchTerm$.next(filterValue);
  }

  applyEmpFilter(ob: MatSelectChange, empfilter: EmpFilter) {
    this.filterDictionary.set(empfilter.name, ob.value);
    var jsonString = JSON.stringify(Array.from(this.filterDictionary.entries()));
    this.filters$.next(jsonString);
  }

  applyEmpFilterNative(event: Event, empfilter: EmpFilter) {
    const value = (event.target as HTMLSelectElement).value;
    this.filterDictionary.set(empfilter.name, value);
    var jsonString = JSON.stringify(Array.from(this.filterDictionary.entries()));
    this.filters$.next(jsonString);
  }

  getTableData$(pageNumber: Number, pageSize: Number, sort: string, order, searchTerm: string, filtersArgs: string) {
    // get data from server
    return this.exhibitorService.getExhibitors(pageNumber, pageSize, sort, order, searchTerm, filtersArgs);
  }

  showPageDetail(exhibitor: Exhibitor) {
    this.exhibitorSelected.emit(exhibitor);
  }

  showExhibitor(exhibitor: Exhibitor) {
    console.log('show the page');

    this.selectedExhibitor = exhibitor;
  }

  sidebarOnClose() {
    console.log('close');
    this.openSidebar = false;
  }

  beautyNamesColumns: string[] = [
    'Generalist tour operator',
    'Specialist tour operator',
    'Tour operator - Own retailing',
    'Tour operator - Retailing through travel agencies',
    'Tour operator member of a holding company',
    'Travel agency',
    'Incentive agency',
    'International incoming agency',
    'Coach company',
    'Car rental company',
    'Hotel booking call center',
    'Air carrier',
    'Sea carrier',
    'Road carrierv',
    'Rail carrier',

    'Number of employees in the company',
    'Volume of travellers Groups to France per year',
    'Volume of Individuals travellers to France per year',
    'Number of brochures per year with France featured',
    'Can we book on line on your website some products featuring France?',
    'Brochure online only',

    'Auvergne - Rhône-Alps',
    'Burgundy-Franche-Comté',
    'Brittany',
    'Corsica',
    'Eastern France',
    'Loire Valley',
    'French Alps',
    'Occitanie',
    'Nouvelle-Aquitaine',
    'Northern France',
    'Normandy',
    'Overseas',
    'Paris and its suburbs',
    'Pays de la Loire',
    'Provence-Alpes Côte dAzur',
    'All France',

    'Business',
    'Beach resorts',
    'Luxury products',
    'Cruises',
    'Barging',
    'Golf',
    'Youth tourism',
    'Summer resorts',
    'Nature',
    'Religious tourism',
    'tailored-made products',
    'Ski',
    'Cultural tours',
    'Champagne, Gastronomy and wine tours',
    'Urban tourism and city break',
    'Active holidays and hiking',

    'Auvergne - Rhône-Alps',
    'Burgundy-Franche-Comté',
    'Brittany',
    'Loire Valley',
    'Eastern France',
    'Corsica',
    'French Alps',
    'Occitanie',
    'Nouvelle-Aquitaine',
    'Northern France',
    'Normandy',
    'Overseas',
    'Paris and ist suburbs',
    'Pays de la Loire',
    'Provence-Alpes Côte dAzur',
    'All France',

    'Hotel group',
    '2-star hotel',
    '3-star hotel',
    '4-star and 5* hotel',
    'Palace hotels',
    'Vacation residence',
    'Holiday club',
    'B&B and private houses rental',
    'Restaurant',
    'Incoming agency',
    'Congress and incentive organisation',
    'Sightseeing & guide',
    'Air and train carrier',
    'Coach carrier',
    'Barging',
    'Leisure or entertainment park',
    'Museum, monument, castle, site',
    'Show, cabaret, theater',
    'Shopping Mall, department store',
    'Tourist office',
    'Others',
  ];

  additionalColumns: string[] = [
    'generalisttour',
    'specialisttour',
    'tourownretailing',
    'tourretailingtravelagencies',
    'touroperatormember',
    'travel',
    'incentive',
    'inernationalincoming',
    'coach',
    'carrental',
    'hotelbookingcallcenter',
    'aircarrier',
    'seacarrier',
    'roadcarrier',
    'railcarrier',

    'numberemployees',
    'volumegroups',
    'volumeindividuals',
    'numberbrochures',
    'onlinebooking',
    'palsace',

    'pauvergne',
    'pburgundy',
    'pbrittany',
    'pcorsica',
    'pchampagne',
    'ploirevalley',
    'pfranche',
    'plancuedoc',
    'plimousin',
    'pnordpasdecalais',
    'pnormandy',
    'poverseas',
    'pparis',
    'pwesternloire',
    'pprovence',
    'pall',

    'pobusiness',
    'pobeach',
    'pochampagne',
    'pocruises',
    'pobarging',
    'pogolf',
    'poyouth',
    'posummer',
    'ponature',
    'poreligious',
    'pofitness',
    'powinter',
    'pocultural',
    'pogastronomy',
    'pourban',
    'poactive',

    'sauvergne',
    'sburgundy',
    'sbrittany',
    'sloire',
    'schampagne',
    'scorsica',
    'sfranche',
    'slanguedoc',
    'slimousin',
    'snordpasdecalais',
    'snormandy',
    'soverseas',
    'sparis',
    'swesternloire',
    'sprovence',
    'sall',

    'khotelgroup',
    'k2starhotel',
    'k3starhotel',
    'k4starhotel',
    'palacehotels',
    'kvacation',
    'kholidayclub',
    'kbandb',
    'krestaurant',
    'kincomingagency',
    'kcongress',
    'gsightseeing',
    'kairtrain',
    'kcoach',
    'kbarging',
    'kleisure',
    'kmuseum',
    'kshow',
    'kmall',
    'ktouristoffice',
  ];
  showAdditionalColumns() {
    this.displayedColumns = this.displayedColumns.concat(this.additionalColumns);
    console.log(this.displayedColumns);
  }

  //
  // ------------------------------- TOTAL SUM CALCULATIONS
  public calculateTotal(fieldname: string) {
    let total = 0;

    const exhibitors = this.dataSource.data;
    switch (fieldname) {
      case 'country':
        total = exhibitors.reduce((accum, curr) => accum + (curr.fax ? 1 : 0), 0);
        break;

      case 'decharge_resp_civile':
        total = exhibitors.reduce((accum, curr) => accum + (curr.decharge_resp_civile > 0 ? +curr.decharge_resp_civile : 0), 0);
        break;

      case 'estimate':
        total = exhibitors.reduce((accum, curr) => accum + +curr.estimate, 0);
        break;

      case 'chkcity1':
        total = exhibitors.reduce((accum, curr) => accum + (curr.chkcity1 > 0 ? +curr.chkcity1 : 0), 0);
        break;

      case 'chkcity2':
        total = exhibitors.reduce((accum, curr) => accum + (curr.chkcity2 > 0 ? +curr.chkcity2 : 0), 0);
        break;

      case 'garage_day1':
        total = exhibitors.reduce((accum, curr) => accum + (curr.garage_day1 > 0 ? +curr.garage_day1 : 0), 0);
        break;

      case 'garage_day2':
        total = exhibitors.reduce((accum, curr) => accum + (curr.garage_day2 > 0 ? +curr.garage_day2 : 0), 0);
        break;

      case 'lunch_day1':
        total = exhibitors.reduce((accum, curr) => accum + (curr.lunch_day1 > 0 ? +curr.lunch_day1 : 0), 0);
        break;

      case 'lunch_day2':
        total = exhibitors.reduce((accum, curr) => accum + (curr.lunch_day2 > 0 ? +curr.lunch_day2 : 0), 0);
        break;

      case 'attendance_event':
        total = exhibitors.reduce((accum, curr) => accum + (curr.attendance_event > 0 ? +curr.attendance_event : 0), 0);
        break;

      case 'hotel_stay_night':
        total = exhibitors.reduce((accum, curr) => accum + (curr.hotel_stay_night > 0 ? +curr.hotel_stay_night : 0), 0);
        break;

      case 'transfer_arrival':
        total = exhibitors.reduce((accum, curr) => accum + (curr.transfer_arrival > 0 ? +curr.transfer_arrival : 0), 0);
        break;

      case 'transfer_return':
        total = exhibitors.reduce((accum, curr) => accum + (curr.transfer_return > 0 ? +curr.transfer_return : 0), 0);
        break;

      case 'flight_booked':
        total = exhibitors.reduce((accum, curr) => accum + (curr.flight_booked > 0 ? +curr.flight_booked : 0), 0);
        break;

      default:
        // there is no default case
        break;
    }
    return total;
  }

  getCountryName(country: string) {
    switch (country) {
      case 'at':
        return 'Austria';
      case 'ba':
        return 'Bosnia-Herzegovina';
      case 'bg':
        return 'Bulgaria';
      case 'hr':
        return 'Croatia';
      case 'cz':
        return 'Czech Republic';
      case 'fr':
        return 'France';
      case 'de':
        return 'Germany';
      case 'hu':
        return 'Hungary';
      case 'xk':
        return 'Kosovo';
      case 'mk':
        return 'Macedonia';
      case 'mne':
        return 'Montenegro';
      case 'pl':
        return 'Poland';
      case 'ro':
        return 'Romania';
      case 'xs':
        return 'Serbia';
      case 'sk':
        return 'Slovakia';
      case 'si':
        return 'Slovenia';
      case 'ch':
        return 'Switzerland';
      default:
        return '';
    }
  }
}
